import ADDRESS_COL from './COL'
import ADDRESS_PER from './PER'
import ADDRESS_BRA from './BRA'

export default {
  COL: ADDRESS_COL,
  PER: ADDRESS_PER,
  BRA: ADDRESS_BRA
}
